export default "<p>insights works!</p>";